import { zl } from "../../../functions/utilities.js";
import { dataFormat4 } from "../../../functions/dataFormat.js";

const MieszkaniecDaneWodaRozliczenieZaliczki = props => {
    
    const { rozliczenieWodyAkt, procent } = props;
    
    return (
        <div className="lewa">
            <table className="tabela">
                <thead>
                    <tr>
                        <th colSpan={2}>
                            {`Naliczone zaliczki za okres ${dataFormat4(rozliczenieWodyAkt?.okresPoczatek)} - ${dataFormat4(rozliczenieWodyAkt?.okresKoniec)}`}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>zimna woda</td>
                        <td className="kwota">
                            { zl(procent?.zaliczka_zw) } 
                        </td>
                    </tr>
                    <tr>
                        <td>abonament cw</td>
                        <td className="kwota">
                            { zl(procent?.zaliczka_abo_cw) }
                        </td>
                    </tr>
                    <tr>
                        <td>ciepła woda</td>
                        <td className="kwota">
                            { zl(procent?.zaliczka_cw) }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenieZaliczki;